import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { firstUserInteraction } from 'a/actions/appSessionActions';

export const useFirstUserInteraction = () => {
  const dispatch = useDispatch();
  const hasUserInteracted = useSelector(state => state.appSessionReducer.hasUserInteracted);
  return useCallback(() => {
    if (!hasUserInteracted) {
      dispatch(firstUserInteraction());
    }
  },
  [hasUserInteracted, dispatch],
  );
};

export default useFirstUserInteraction;
